import { Row, Col } from "react-bootstrap";

import classes from "./pagination.module.scss";

import NewPagination from "./NewPagination";

const BasePagination = ({ page, paginate, last_page, quantity, from, to, setPage, setPaginate }) => {
	return (
		<Row style={{ padding: "2px 5px", alignItems: "center" }} className="g-2">
			<Col md={3} xs={12} className={classes.unit}>
				<span style={{ fontSize: "13px", paddingRight: "5px" }}>Mostrar </span>
				<select
					className={classes.selectUnit}
					value={paginate}
					onChange={(e) => {
						setPage(1);
						setPaginate(e.target.value);
					}}
				>
					<option value="10">10</option>
					<option value="20">20</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
				<span style={{ fontSize: "13px", paddingLeft: "5px" }}>registros</span>
			</Col>
			<Col md={{ span: 4, offset: 5 }} xs={12}>
				<NewPagination last_page={last_page} page={page} setPage={setPage} quantity={quantity} from={from} to={to} />
			</Col>
		</Row>
	);
};

export default BasePagination;
